import { render } from "./EditSpecials.vue?vue&type=template&id=1a28d9af&scoped=true"
import script from "./EditSpecials.vue?vue&type=script&lang=js"
export * from "./EditSpecials.vue?vue&type=script&lang=js"

import "./EditSpecials.vue?vue&type=style&index=0&id=1a28d9af&lang=scss&scoped=true"
import "./EditSpecials.vue?vue&type=style&index=1&id=1a28d9af&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1a28d9af"]])

export default __exports__